export const state = () => ({
  playInfo: {
    curServer: {}
  }
})

export const mutations = {
  setCurServer(state, curServer) {
    state.playInfo.curServer = curServer
  }
}

export const actions = {}
